
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import i08 from "../../img/1280/16x9/Paypal_Login.png"

const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Image = makeShortcode("Image");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Image src={i08} mdxType="Image" />
    <h1>{`Paypal_Login`}</h1>
    <p>{`Was man nicht alles mit einer E-Mail und dem gleichen Passwort hacken kann.`}</p>
    <p>{`Der Code ist wird dir ja jetzt klar sein. :)`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;